import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import "@olmokit/core/forms/checkbox";
import FormsTextareaMaterial from "@olmokit/core/forms/textarea/material";
import Olmoforms from "@olmokit/core/olmoforms/feedback";
import Dependency from "@olmokit/core/olmoforms/dependency";
import { $, on } from "@olmokit/dom";
import { countryEndpoint, hideProject, showProject } from "components/Form";
import { dataLayerFillingForm, dataLayerForm } from "components/Datalayer";
import { salesforceCommunication } from "components/Form";
import "./Dealer.scss";

/**
 * Component: FormProductCart
 */
export function FormDealer() {
  console.log("FormDealer mounted.");

  dataLayerFillingForm('#contactdealer .of:el', 'Form Dealer')

  const $container = $('.FormDealer: .of:country');
  const $country = $('select', $container);

  on($country, 'change', () => {   
    countryEndpoint(".FormDealer:", $country.value);
  });

  const $jobcontainer = $('.FormDealer: .of:job');
  const $jobfield = $('select', $jobcontainer);
  const $projcontainer = $('.FormDealer: .of:project');
  const $projfield = $('select', $projcontainer);
  const $mqcontainer = $('.FormDealer: .of:projectmq');
  const $yearcontainer = $('.FormDealer: .of:projectyear');

  on($jobfield, 'change', () => {   
    if ($jobfield.value == 'Press Stampa') {
      hideProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);
    } else {
      $projcontainer.style.display = 'block';
      showProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);      
    }
  });
  on($projfield, 'change', () => {
    showProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);
  })

  const olmoforms = Olmoforms(".FormDealer:", {
    before: (formData) => {
      console.log(formData);
      const $localcheck = $('#of-4-localcheck');
      if($localcheck.value != ''){
        console.log('stopped');
        olmoforms.boot()
      }
    },    
    sent: (formData) => {
      dataLayerForm("form sent", formData, "Form Dealer", $('#of-3-usertype').value, $('#of-3-requesttype').value);
      salesforceCommunication(formData, "Form Dealer");
    }, 
    failed: (instance) => dataLayerForm("form_error", '', "Form Dealer", $('#of-3-usertype').value, $('#of-3-requesttype').value)
  });

  FormsInputMaterial();
  Dependency(".FormDealer:");
  FormsSelectMaterial();
  FormsTextareaMaterial();

  return {
    destroy() {
      olmoforms.destroy();
    },
  };


}
